<template lang="pug">
	.track-url-actions
		.track-url-events(v-if="_.size(settingValue) > 0")
			// Добавление класса нужно для туториала
			.track-url-event(:class="'event-name-' + _.kebabCase(eventName)" v-for="(eventObject, eventName) in settingValue")
				.track-url-event-description(v-if="_.find(events, event => event.name === eventName)")
					.text-muted {{_.find(events, event => event.name === eventName).description}}
				.track-url-event-name
					select.custom-select.custom-select-sm(v-on:change="changeEvent(eventName, $event.target.value)")
						option(v-for="event in events" :selected="eventName === event.name" :value="event.name") {{event.title || event.name}}
					.track-url-event-remove(@click="removeEvent(eventName)")
						i.fa.fa-times
				.track-url-event-urls
					.track-url-event-url(v-for="(urlObject, index) in eventObject")
						input.form-control.form-control-sm(type="text" :value="urlObject.url" v-on:change="setUrl(eventName, $event.target.value, index, $event.target)")
						.track-url-event-url-setting.tracking-type
							span.text-muted.title Tracking type
							span
								select.custom-select.custom-select-sm(v-on:change="setUrlType(urlObject, $event.target.value)")
									option(:selected="urlObject.trackingType === 'xhr'" value="xhr") XHR
									option(:selected="urlObject.trackingType === 'img'" value="img") Image
									option(:selected="urlObject.trackingType === 'script'" value="script") Script
									option(:selected="urlObject.trackingType === 'matomo'" value="matomo") Matomo
						.track-url-event-url-setting.track-multiple
							span.text-muted.title Track only first event
							label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
								input.switch-input.form-check-input(type="checkbox" :checked="!urlObject.trackMultiple" @change="setUrlMultiple(urlObject, !$event.target.checked)")
								span.switch-slider(data-checked="On" data-unchecked="Off")
								span.switch-handle
					input.form-control.form-control-sm(type="text" :placeholder="eventObject.length > 0 ? 'put additional url here...' : 'put url here...'" v-on:change="setUrl(eventName, $event.target.value, null, $event.target)")
		.add-new-event
			select.custom-select.custom-select-sm(v-on:change="addNewEvent($event.target)")
				option(:selected="true" value="none") Add new event
				option(v-for="event in events" v-if="!settingValue[event.name]" :selected="false" :value="event.name") {{event.title || event.name}}
</template>

<script>

	import Screen 				from './../../../mixins/screen';

	import { Creative } 			from './../../../services/Creative';
	import { Settings } 		from './../../../services/Settings';
	import { Version } 			from './../../../services/Version';

	export default {
		name: "TrackUrlActions",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Switched", "Selected Version Fully Loaded"]
		},
		props: ['setting'],
		data() {

			this.Creative = Creative;
			this.Settings = Settings;

			this.events = [];
			this.settingValue = {};

			return {
				showed: true
			}

		},
		mounted() {

			//Сообщаем компоненту что он должен обновляться при изменении указанных настроек активной версии креатива
			this.addUpdateEvent([`Selected Version Setting Changed:track-url-actions`, `Selected Version Setting Changed:track-events`]);

		},
		methods: {
			collectData() {

				if (!Version.SelectedVersion || !this.setting || !Settings.isSettingExist(this.setting.codename)) return console.log('TrackUrlActions collectData FAILED', this.setting?.['codename'], Version.SelectedVersion?.id, this.setting?.['version_id']);

				this.events = Settings.getTrackingEvents();
				this.settingValue = Settings.getSettingValue(this.setting.codename) || {};

			},
			addNewEvent(el) {

				if (el.value === "none") return;

				if (this.settingValue[el.value]) return;

				this.settingValue[el.value] = [];

				this.$forceUpdate();

				el.value = 'none';

				this.delaySave();

			},
			changeEvent(oldEvent, newEvent) {

				if (this.settingValue[newEvent]) return;

				this.settingValue[newEvent] = this.settingValue[oldEvent];

				delete this.settingValue[oldEvent];

				this.$forceUpdate();

				this.delaySave();

			},
			removeEvent(eventName) {

				delete this.settingValue[eventName];

				this.$forceUpdate();

				this.delaySave();

			},
			setUrl(eventName, url, index, el) {

				console.log(eventName, url, index, this.settingValue);

				if (!this.settingValue[eventName]) return;

				if (typeof index === "number") {

					if (!url) this.settingValue[eventName].splice(index, 1);

					else this.settingValue[eventName][index].url = url;

				} else {

					if (url) this.settingValue[eventName].push({url, trackingType: 'xhr', trackMultiple: false});

					el.value = '';

				}

				this.$forceUpdate();

				this.delaySave();

			},
			setUrlType(urlObject, trackingType) {

				urlObject.trackingType = trackingType;

				this.$forceUpdate();

				this.delaySave();

			},
			setUrlMultiple(urlObject, trackMultiple) {

				urlObject.trackMultiple = trackMultiple;

				this.$forceUpdate();

				this.delaySave();

			},
			delaySave() {

				clearTimeout(this.saveTimeout);
				this.saveTimeout = setTimeout(() => {

					Server.sendToSocket({
						UpdateCreativeVersionSetting: {
							versionId: Version.SelectedVersion.id,
							settingCodename: this.setting.codename,
							value: this.settingValue
						}
					});

				}, 200);

			}
		}
	}
</script>

<style lang="sass">

	.track-url-actions
		display: flex
		justify-content: space-between
		user-select: none
		position: relative
		flex-direction: column

		.custom-select
			cursor: pointer
			color: #fff
			width: auto
			background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
			background-color: #343b41
			border: 1px solid #23282c
			margin-top: 0
			float: none !important

			&.selected
				background-color: #4dbd74

		.track-url-events
			position: relative
			margin-top: 5px
			border: 1px solid #23282c
			border-radius: 5px
			background-color: #343b41
			font-size: 12px
			overflow: hidden

			.track-url-event
				display: flex
				flex-direction: column
				position: relative
				user-select: none

				&:not(:first-child)
					border-top: 1px solid rgba(0, 0, 0, 0.1)

				&:hover
					background-color: #2f363c

				.track-url-event-description
					.text-muted
						font-size: 12px

				.track-url-event-name
					display: flex
					flex-direction: row
					justify-content: space-between
					padding: 0 5px 5px 5px

					.custom-select
						width: 315px

					.track-url-event-remove
						cursor: pointer
						transition: 0.2s
						padding: 4px 7px
						font-size: 14px
						color: #fff

						&:hover
							color: #20a8d8

						.fa-times
							padding-top: 8px

			.track-url-event-description
				padding: 5px 5px 0px 5px

			.track-url-event-urls
				padding: 5px 5px 0px 5px

				input.form-control
					margin-bottom: 5px

			.track-url-event-url

				.track-url-event-url-setting
					display: flex
					flex-direction: row
					justify-content: space-between
					align-items: center
					padding-bottom: 10px

					&.track-multiple
						border-bottom: 1px solid #23282c
						margin-bottom: 10px

</style>
